<template>

  <form v-on:submit.prevent="">

    <multiselect v-model="form.costCenter"
                 :custom-label="costCenterLabel"
                 :hide-selected="true"
                 :options="[1, 2, 3]"
                 :show-labels="false"
                 placeholder="Kostenstelle">
      <template #placeholder>
        <font-awesome-icon icon="file-invoice-dollar"/>
        <span>Kostenstelle</span>
      </template>
      <template #singleLabel="props">
        <font-awesome-icon icon="file-invoice-dollar"/>
        <span>{{ costCenterLabel(props.option) }}</span>
      </template>
    </multiselect>

    <v-date-picker
      v-model="form.date"
      :popover="{ visibility: 'click' }"
      :is-dark="darkmodeStatus"
      color="blue"
      is24hr
      mode="date"
      title-position="left">
      <template v-slot="{ inputValue, inputEvents }">
        <div class="input-wrapper-floatinglabel">
          <font-awesome-icon icon="calendar-day"/>
          <input
            placeholder="Datum"
            type="text"
            :value="inputValue"
            required
            v-on="inputEvents"/>
          <label>
            Datum
          </label>
        </div>
      </template>
    </v-date-picker>

    <BaseInputFloatinglabel
      v-model="form.number"
      icon="file-invoice-dollar"
      placeholder="Nummer"
      type="text"/>

    <BaseTextarea
      v-model="form.notes"
      icon="sticky-note"
      placeholder="Notizen"/>

    <BaseInputFloatinglabel
      v-model="form.amount" icon="euro-sign"
      placeholder="Betrag"
      step="0.01"
      type="number"/>

    <multiselect v-model="form.status"
                 :options="['Offen', 'Bezahlt']"
                 :show-labels="false"
                 placeholder="Status">
      <template #placeholder>
        <font-awesome-icon icon="file-invoice-dollar"/>
        <span>Status</span>
      </template>
      <template #singleLabel="props">
        <font-awesome-icon icon="file-invoice-dollar"/>
        <span>{{ props.option }}</span>
      </template>
    </multiselect>

    <BaseCheckbox v-if="projectAccountingInvoice.costCenter && hasChiefRole"
                  v-model="form.isPublic"
                  field="isPublic"
                  placeholder="Sichtbar"/>

    <div class="action">
      <BaseButton v-if="type === 'create'"
                   :loading="creating"
                   :disabled="checkForm || creating"
                   icon="plus"
                   label="Erstellen"
                   :submit="true"
                   @click="create"/>
      <BaseButton v-if="isManager && type === 'edit'"
                   :loading="removing"
                   :disabled="removing"
                   icon="trash"
                   label="Löschen"
                   :remove="true"
                   @click="remove"/>
      <BaseButton v-if="type === 'edit'"
                   :loading="updating"
                   :disabled="checkForm || updating"
                   icon="save"
                   label="Speichern"
                   :submit="true"
                   @click="update"/>
    </div>

  </form>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'ProjectAccountingInvoiceForm',
  props: ['projectAccountingInvoice', 'type'],
  data () {
    return {
      form: {},
      creating: false,
      updating: false,
      removing: false
    }
  },
  created () {
    this.form = cloneDeep(this.projectAccountingInvoice)
  },
  methods: {
    async create () {
      try {
        this.creating = true
        await this.createProjectAccountingInvoice({ data: this.form })
        this.$vfm.hide('project-accounting-invoice-create')
        this.$toasted.success('Rechnung erstellt', { icon: 'fas fa-file-invoice-dollar' })
        this.creating = false
      } catch (error) {
        this.creating = false
      }
    },
    async update () {
      try {
        this.updating = true
        await this.updateProjectAccountingInvoice({
          id: this.form.id,
          data: this.form
        })
        this.$vfm.hide('project-accounting-invoice-edit')
        this.$toasted.success('Rechnung gespeichert', { icon: 'fas fa-file-invoice-dollar' })
        this.updating = false
      } catch (error) {
        this.updating = false
      }
    },
    async remove () {
      try {
        this.removing = true
        await this.deleteProjectAccountingInvoice({ id: this.form.id })
        this.$vfm.hide('project-accounting-invoice-edit')
        this.$toasted.success('Rechnung gelöscht', { icon: 'fas fa-file-invoice-dollar' })
        this.removing = false
      } catch (error) {
        this.removing = false
      }
    },
    costCenterLabel (costCenter) {
      switch (costCenter) {
        case 1:
          return 'PR'
        case 2:
          return 'Social Media'
        case 3:
          return 'Marketing'
      }
    },
    ...mapActions({
      createProjectAccountingInvoice: 'projectAccountingInvoices/create',
      updateProjectAccountingInvoice: 'projectAccountingInvoices/replace',
      deleteProjectAccountingInvoice: 'projectAccountingInvoices/destroy',
      getProjectAccountingInvoices: 'projectAccountingInvoices/fetchList'
    })
  },
  computed: {
    project () {
      return this.projectById(this.$route.params.projectId)
    },
    isManager () {
      return (this.project && this.project.managers && this.project.managers.some(user => user.id === this.authUser.id)) || this.hasManagerRole
    },
    checkForm () {
      return false
    },
    ...mapGetters({
      projectById: 'projects/byId',
      authUser: 'auth/authUser',
      hasManagerRole: 'auth/hasManagerRole',
      hasChiefRole: 'auth/hasChiefRole',
      darkmodeStatus: 'app/darkmodeStatus'
    })
  }
}
</script>
